import {
  AccordionDetails,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { formatInput } from 'src/util/STR';

const PriorToVisit: React.FunctionComponent<any> = ({
  priorToVisitUpdate,
  sqChecklistPILFormData,
  setSqChecklistPILFormData,
  setIsNavigateToPannel,
  checkedInStartDate
}) => {
  const { priorToTheVisit } = useFieldTranslation();
  const dispatch = useDispatch();
  const [isSaveBtnEnable, setIsSaveBtnEnable] = React.useState(false);
  const { checkPermission } = usePermissionWrapper();
  const isDisable = checkPermission('update_sq_checklist_pil');

  const handleCheckBox = (e: any) => {
    const data = e.target.checked ? true : false;
    setSqChecklistPILFormData({ ...sqChecklistPILFormData, [e.target.name]: data });
    setConfirmExitValue(dispatch, true);
    setIsSaveBtnEnable(true);
  };

  const handleCheck = (e: any) => {
    const data = e.target.value;
    const formattedVal = typeof data === 'string' ? formatInput(data) : data;
    setSqChecklistPILFormData({ ...sqChecklistPILFormData, [e.target.name]: formattedVal });
    setConfirmExitValue(dispatch, true);
    setIsSaveBtnEnable(true);
    setIsNavigateToPannel(false);
  };

  return (
    <AccordionDetails className="sq-checklist-tab">
      <Grid container className="checkbox-block">
        <Grid spacing={3} container className="date-block">
          <Grid item md={8}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{priorToTheVisit.label1}</Typography>}
                  value={sqChecklistPILFormData.sq_reg_meeting_mil_track}
                  name="sq_reg_meeting_mil_track"
                  checked={sqChecklistPILFormData.sq_reg_meeting_mil_track == true ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid md={4} className="comment-section">
            <FormControl fullWidth margin="normal" className="comment-input">
              <TextField
                name="sq_reg_meeting_mil_track_comm"
                label="Comment"
                variant="standard"
                value={sqChecklistPILFormData.sq_reg_meeting_mil_track_comm || ''}
                inputProps={{ maxLength: 199 }}
                onChange={handleCheck}
                disabled={!sqChecklistPILFormData.sq_reg_meeting_mil_track || !checkedInStartDate}
              />
            </FormControl>
          </Grid>

          <Grid item md={8}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{priorToTheVisit.label2}</Typography>}
                  value={sqChecklistPILFormData.sq_protocol_review_mil_track}
                  name="sq_protocol_review_mil_track"
                  checked={sqChecklistPILFormData.sq_protocol_review_mil_track ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid md={4} className="comment-section">
            <FormControl fullWidth margin="normal" className="comment-input">
              <TextField
                name="sq_protocol_review_mil_track_comm"
                label="Comment"
                variant="standard"
                value={sqChecklistPILFormData.sq_protocol_review_mil_track_comm || ''}
                inputProps={{ maxLength: 199 }}
                onChange={handleCheck}
                disabled={!sqChecklistPILFormData.sq_protocol_review_mil_track || !checkedInStartDate}
              />
            </FormControl>
          </Grid>

          <Grid item md={8}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{priorToTheVisit.label3}</Typography>}
                  value={sqChecklistPILFormData.sq_contract_tim_mil_track}
                  name="sq_contract_tim_mil_track"
                  checked={sqChecklistPILFormData.sq_contract_tim_mil_track ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid md={4} className="comment-section">
            <FormControl fullWidth margin="normal" className="comment-input">
              <TextField
                name="sq_contract_tim_mil_track_comm"
                label="Comment"
                variant="standard"
                value={sqChecklistPILFormData.sq_contract_tim_mil_track_comm || ''}
                inputProps={{ maxLength: 199 }}
                onChange={handleCheck}
                disabled={!sqChecklistPILFormData.sq_contract_tim_mil_track || !checkedInStartDate}
              />
            </FormControl>
          </Grid>

          <Grid item md={8}>
            <FormControl>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox />}
                  label={<Typography variant="body2">{priorToTheVisit.label4}</Typography>}
                  value={sqChecklistPILFormData.sq_contract_review_name}
                  name="sq_contract_review_name"
                  checked={sqChecklistPILFormData.sq_contract_review_name ? true : false}
                  onChange={handleCheckBox}
                  disabled={!isDisable || !checkedInStartDate}
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid md={4} className="comment-section">
            <FormControl fullWidth margin="normal" className="comment-input">
              <TextField
                name="sq_contract_review_name_comm"
                label="Comment"
                variant="standard"
                value={sqChecklistPILFormData.sq_contract_review_name_comm || ''}
                inputProps={{ maxLength: 199 }}
                onChange={handleCheck}
                disabled={!sqChecklistPILFormData.sq_contract_review_name || !checkedInStartDate}
              />
            </FormControl>
          </Grid>

          <Grid container spacing={2}>
            <Grid item md={12} display="flex" justifyContent="flex-end">
              <Stack spacing={2} direction="row">
                {isDisable ? (
                  <Button
                    disabled={!isSaveBtnEnable || !checkedInStartDate}
                    onClick={() => {
                      priorToVisitUpdate(sqChecklistPILFormData);
                      setIsSaveBtnEnable(false);
                      setIsNavigateToPannel(true);
                    }}
                    variant="text"
                  >
                    SAVE
                  </Button>
                ) : (
                  ''
                )}
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AccordionDetails>
  );
};

export default PriorToVisit;
